import { authApi } from './authApi';
import {
  PublicEntityCreate,
  PublicEntityUpdate,
  PublicEntityResponse,
  PublicEntityDetailResponse,
  PaginatedPublicEntityResponse,
  PublicEntitySimpleResponse,
} from '../types/publicEntity';

/**
 * Obtém lista paginada de entidades (Connect).
 * GET /public-entities/
 */
export const getPublicEntities = async (
  cityId?: string,
  page: number = 1,
  size: number = 10
): Promise<PaginatedPublicEntityResponse> => {
  const params: any = { page, size };
  if (cityId) {
    params.city_id = cityId;
  }
  const response = await authApi.get<PaginatedPublicEntityResponse>('/public-entities/', { params });
  return response.data;
};

/**
 * Obtém detalhes de uma entidade (Connect).
 * GET /public-entities/{id}/
 */
export const getPublicEntity = async (entityId: string): Promise<PublicEntityDetailResponse> => {
  const response = await authApi.get<PublicEntityDetailResponse>(`/public-entities/${entityId}/`);
  return response.data;
};

/**
 * Cria uma nova entidade (Connect).
 * POST /public-entities/
 */
export const createPublicEntity = async (
  entityData: PublicEntityCreate
): Promise<PublicEntityResponse> => {
  const response = await authApi.post<PublicEntityResponse>('/public-entities/', entityData);
  return response.data;
};

/**
 * Atualiza entidade (Connect).
 * PUT /public-entities/{id}/
 */
export const updatePublicEntity = async (
  entityId: string,
  entityData: PublicEntityUpdate
): Promise<PublicEntityResponse> => {
  const response = await authApi.put<PublicEntityResponse>(`/public-entities/${entityId}/`, entityData);
  return response.data;
};

/**
 * Deleta entidade (Connect).
 * DELETE /public-entities/{id}/
 */
export const deletePublicEntity = async (entityId: string): Promise<{ detail: string }> => {
  const response = await authApi.delete<{ detail: string }>(`/public-entities/${entityId}/`);
  return response.data;
};

/**
 * Todas as entidades (Connect).
 * GET /public-entities/all/
 */
export const getAllPublicEntitiesSimple = async (): Promise<PublicEntitySimpleResponse[]> => {
  const response = await authApi.get<PublicEntitySimpleResponse[]>('/public-entities/all/');
  return response.data;
};